import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DataAttributeDirective } from '@shared/directives/data-attribute.directive';
import { UserBalanceInfoComponent } from './components/user-balance-info/user-balance-info.component';
import { AsyncPipe } from '@angular/common';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { ProfileInfoComponent } from '../../../profile-info/profile-info.component';
import { NotificationBellComponent } from './components/notification-bell/notification-bell.component';
import { HeaderUserInfoBaseComponent } from '../../base/header-user-info-base/header-user-info-base.component';
import { ShowOnPlatformNarrowDirective } from '@shared/directives/show-on-platform-narrow.directive';
import { ManagerDialogConstructor } from '@services/utils/manager-dialog-constructor.service';
import { AssistanceInSelectionService } from '@services/utils/assistance-in-selection.service';
import { SelectionHelperComponent } from './components/selection-helper/selection-helper.component';
import { LogoComponent } from '../../../logo/logo.component';

@Component({
  selector: 'b2b-portal-header-user-info',
  templateUrl: './header-user-info.component.html',
  styleUrls: ['./header-user-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DataAttributeDirective,
    UserBalanceInfoComponent,
    AsyncPipe,
    LanguageSelectorComponent,
    ProfileInfoComponent,
    NotificationBellComponent,
    ShowOnPlatformNarrowDirective,
    SelectionHelperComponent,
    LogoComponent,
  ],
  providers: [ManagerDialogConstructor, AssistanceInSelectionService],
})
export class HeaderUserInfoComponent extends HeaderUserInfoBaseComponent {}
